import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const providers = [
  {
    name: "The Great Glenorchy Alpine Base Camp",
    blurb:
      "Boutique alpine accommodation, wood-fired Base Camp Kitchen and guided adventures, just 45 minutes from the studio at the foot of the Southern Alps.",
    url: "https://thegreatglenorchyalpinebasecamp.co.nz",
    tag: "Accommodation · Adventure",
  },
  {
    name: "Venator NZ",
    blurb:
      "Luxury Wānaka hunting estate and lodges; five-star talent retreats, fine dining and signature New Zealand outdoor experiences.",
    url: "https://www.venator.co/new-zealand/overview",
    tag: "Hospitality · Lodges",
  },
  {
    name: "Paradise Trust",
    blurb:
      "Charitable trust offering rustic wilderness accommodation on a 300-acre Paradise property near Glenorchy. Historic cottages and venue spaces with unbeatable mountain access.",
    url: "https://paradisetrust.nz",
    tag: "Wilderness · Heritage Stays",
  },
  {
    name: "Heli Glenorchy",
    blurb:
      "Glenorchy based scenic and utility helicopter operator, alpine landings, aerial cinematography support, talent transfers and search-and-rescue capability across the Southern Alps.",
    url: "https://www.heliglenorchy.co.nz",
    tag: "Aviation · Aerial Support",
  },
];

export default function Providers() {
  return (
    <section
      id="providers"
      data-testid="providers-section"
      className="relative py-28 md:py-36 border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-6 h-px bg-[#E2B464]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E2B464]">
                Preferred Service Providers
              </span>
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-[0.95] tracking-tighter">
              A vetted network,{" "}
              <span className="italic text-[#E2B464]">on call.</span>
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 self-end text-zinc-400 leading-relaxed">
            We connect productions to a trusted circle of regional partners
            accommodation, hospitality, transport and guides so your shoot day
            extends seamlessly into your crew's downtime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {providers.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`provider-link-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative bg-[#0a0a0a] border border-white/10 hover:border-[#E2B464]/60 transition-colors p-8 md:p-10 flex flex-col gap-6"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">
                  {p.tag}
                </span>
                <ArrowUpRight className="w-5 h-5 text-zinc-500 group-hover:text-[#E2B464] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl text-white tracking-tight leading-tight group-hover:text-[#E2B464] transition-colors">
                  {p.name}
                </h3>
                <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
                  {p.blurb}
                </p>
              </div>
              <div className="mt-auto pt-4 border-t border-white/10 flex items-center justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 truncate">
                  {p.url.replace(/^https?:\/\//, "")}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#E2B464]">
                  Visit
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
